import React from "react";
import { Form, Drawer, Button, Select, Table, List, InputNumber } from "antd";
import { PlusOutlined, MinusOutlined } from "@ant-design/icons";

const InputNumberCart = ({ value, onChange }) => {
  return (
    <div className="sm:w-[115px] w-[95px] h-[35px] sm:h-[40px] flex flex-row border rounded border-[#D9D9D9]">
      <button
        className="flex flex-1 justify-center items-center border-r border-[#D9D9D9]"
        onClick={() => {
          if (value == 1) return
          const _value = parseInt(value) - 1;
          onChange(_value);
        }}
      >
        <MinusOutlined />
      </button>
      <InputNumber
        onChange={onChange}
        min={1}
        value={value}
        bordered={false}
        controls={false}
        className="input-number-cart flex flex-2 justify-center items-center text-center"
      />
      <button
        className="flex flex-1 justify-center items-center border-l border-[#D9D9D9]"
        onClick={() => {
          const _value = parseInt(value) + 1;
          onChange(_value);
        }}
      >
        <PlusOutlined />
      </button>
    </div>
  );
};

export default InputNumberCart;
